import { createClient as createContentfulClient } from 'contentful';
import { getRequestEvent } from 'solid-js/web';
import type { ContentfulClientApi } from 'contentful';

let client: ContentfulClientApi<undefined>;
let preview: ContentfulClientApi<undefined>;

type Config = {
	accessToken: string;
	spaceId: string;
	preview?: { accessToken: string; spaceId: string };
};

export function getClient() {
	const url = getRequestEvent()?.request.url ? new URL(getRequestEvent()!.request.url) : null;
	const usePreview = url?.searchParams.get('preview');

	if (usePreview) {
		return preview!;
	}

	return client;
}

export function initClient(config: Config) {
	if (config.preview) {
		preview ??= createContentfulClient({
			space: config.preview.spaceId,
			accessToken: config.preview.accessToken,
			host: 'preview.contentful.com',
		});
	}

	if (!client && config.spaceId) {
		client = createContentfulClient({
			space: config.spaceId,
			accessToken: config.accessToken,
		});
	}
}
